/** Brand/scope FAQs surfaced on the homepage and emitted as FAQPage JSON-LD.
 *  English fallback strings are the canonical source — translators add
 *  localized variants via the i18n key. */
export interface HomepageFaq {
  questionKey: string;
  questionFallback: string;
  answerKey: string;
  answerFallback: string;
}

export const HOMEPAGE_FAQS: HomepageFaq[] = [
  {
    questionKey: 'ui.faq.what_is_q',
    questionFallback: 'What is vacant.day?',
    answerKey: 'ui.faq.what_is_a',
    answerFallback:
      'vacant.day is a free, multilingual world calendar covering public holidays, religious observances, cultural festivals, academic calendars, and long weekends across 14 countries — with no account required and no paywall.',
  },
  {
    questionKey: 'ui.faq.countries_q',
    questionFallback: 'Which countries does vacant.day cover?',
    answerKey: 'ui.faq.countries_a',
    answerFallback:
      'Indonesia, India, Malaysia, Singapore, Afghanistan, Ethiopia, Myanmar, Mongolia, Laos, Iraq, Sudan, Yemen, Syria, and Tibet — with more added regularly. Each country has dedicated holiday, festival, and academic calendar pages.',
  },
  {
    questionKey: 'ui.faq.languages_q',
    questionFallback: 'What languages are supported?',
    answerKey: 'ui.faq.languages_a',
    answerFallback:
      'English, Bahasa Indonesia, Bahasa Malaysia, Arabic, Hindi, Tamil, Burmese, Lao, Mongolian, Spanish, French, German, Chinese, Japanese, Filipino, and other localized variants — about 20 in total.',
  },
  {
    questionKey: 'ui.faq.sources_q',
    questionFallback: 'Where does the data come from?',
    answerKey: 'ui.faq.sources_a',
    answerFallback:
      "Primary sources include national government publications, ministries of religious affairs, university registrars, and official tourism boards. Secondary sources are used for cross-validation. Academic calendars come directly from each university's published schedule.",
  },
  {
    questionKey: 'ui.faq.update_freq_q',
    questionFallback: 'How often is the data updated?',
    answerKey: 'ui.faq.update_freq_a',
    answerFallback:
      'Automated weekly checks against source publications, plus manual review for high-stakes dates such as academic calendars and lunar/Islamic dates that may shift after initial publication.',
  },
  {
    questionKey: 'ui.faq.cost_q',
    questionFallback: 'Is vacant.day free?',
    answerKey: 'ui.faq.cost_a',
    answerFallback:
      'Yes — every page is free to use, no account required, and there is no paywall. The site is supported by occasional contextual ads and affiliate links on relevant travel pages.',
  },
  {
    questionKey: 'ui.faq.commercial_q',
    questionFallback: 'Can I cite vacant.day data in my own work?',
    answerKey: 'ui.faq.commercial_a',
    answerFallback:
      'Yes, with attribution. Link to the canonical page for the specific holiday or country, and note the date you retrieved the data — calendar dates can shift for lunar, Islamic, and academic calendars.',
  },
  {
    questionKey: 'ui.faq.academic_q',
    questionFallback: 'Does vacant.day include university academic calendars?',
    answerKey: 'ui.faq.academic_a',
    answerFallback:
      'Yes — academic calendars for many universities across Indonesia, Malaysia, Philippines, India, Thailand, and Vietnam, including semester dates, exam periods, holidays, and orientation week.',
  },
  {
    questionKey: 'ui.faq.long_weekends_q',
    questionFallback: 'How are long weekends calculated?',
    answerKey: 'ui.faq.long_weekends_a',
    answerFallback:
      "Long weekends are computed from each country's public holiday list. Each entry shows the existing days off plus any bridge-day leave needed to extend the weekend, with the total days off you would gain.",
  },
  {
    questionKey: 'ui.faq.report_q',
    questionFallback: 'I found an incorrect date. How do I report it?',
    answerKey: 'ui.faq.report_a',
    answerFallback:
      'Every event detail page has a Report button at the bottom. Submissions are reviewed against source documents and corrected within a few days for time-sensitive dates.',
  },
];
